import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import { Icon, Upload, message, Steps, Button, Alert } from 'antd';
import Lottie from 'react-lottie';
import writeXlsxFile from 'write-excel-file';
import readXlsxFile from 'read-excel-file';
import { readSheetNames } from 'read-excel-file';
import {
  pdfAnimationData,
  emailAnimationData,
  callAnimationData,
  smsAnimationData,
  whatsappAnimationData,
} from './lottieFiles';
import {
  Container,
  TemplateConatiner,
  EmptySettingsDetails,
  LoaderContainer,
  TemplateWrapper,
  TemplatePageOverview,
  TemplateImage,
  ErrorMessage,
  BulkUploadButton,
  UploadSteps,
  TemplateTitleSec,
  TempDetails,
} from './styles';
import URL from '../../utils/helper';

import EmptyElementsIllustration from '../../images/empty-elements.svg';
import Loader from '../../components/Loader';
import { getAllPublishedtemplate } from '../../utils/services/templatesAPI';
import { getAllPublishedMessages } from '../../utils/services/shortMessageTemplateAPI';
import { uploadDataSet } from '../../utils/services/documentAPI';
import { uploadEmailDataSet } from '../../utils/services/mailTemplateAPI';
import { getEmailAuditDetails } from '../../utils/services/emailAuditAPI';
import { uploadMessagesDataSet } from '../../utils/services/shortMessageTemplateAPI';
import VariableUploadResultModal from '../../components/Modals/VariableUploadResultModal';
import VariableDetailsModal from '../../components/Modals/VariableDetailsModal';
import {
  SendEmailIcon,
  smsSvgIcon,
  callSvgIcon,
  whatsappSvgIcon,
} from '../../../src/images/svgIcons';
import { getTagsList } from '../../utils/services/mailRoomAPI';

// app store context API
import { AppStoreContext } from '../../context/appStoreContext';
import { UploadVariableSvg, PDFSvg, EmailIcon } from '../../components/SidebarMenuIcons';
import { CALL_TRANSACTIONS, EMAIL_TRANSACTIONS, MESSAGE_TRANSACTIONS, PDF_TRANSACTIONS, TRANSACTIONS, WHATSAPP_TRANSACTIONS } from './translationValues';
import { withTranslation } from 'react-i18next';
import * as XLSX from 'xlsx';
import { VARIABLE_TYPE } from '../../utils/constants/appConstants';
import { convertExcelSerialDate } from '../../utils/javascript';
import { checkFileFormat } from './Utils';

const NAMESPACES = ['TRANSACTIONS', 'PDF_TRANSACTIONS', 'EMAIL_TRANSACTIONS', 'CALL_TRANSACTIONS', 'MESSAGE_TRANSACTIONS', 'WHATSAPP_TRANSACTIONS'];

const PublishedTemplates = props => {
  const {
    tempCategories,
    isMailTemplates,
    page,
    filterByCateg,
    searchVal,
    searchTag,
    onTempSelection,
    isPublishedMessages,
    publishedMessageType,
    t
  } = props;
  const { loginVisible, globalVariables, checkUserAccess } = useContext(
    AppStoreContext,
  );
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [totalTemplates, setTotalTemplates] = useState(null);
  const [templatesList, setTemplatesList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isUploading, setIsUploading] = useState(false);
  const [downloadZip, setDownloadZip] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [generatingPdf, setIsgeneratingPdf] = useState(false);
  const [downloadedZip, setDownloadedZip] = useState(false);
  const [isUploadFailed, setIsUploadFailed] = useState(false);
  const [reqMailId, setReqMailId] = useState([]);
  const [reqMailStatus, setReqMailStatus] = useState([]);
  const [tagsData, setTagsData] = useState([]);
  const [isViewTagDetails, setViewTagDetails] = useState(false);
  const [isViewMissedList, setViewMissedList] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [isViewVarDetails, setIsViewVarDetails] = useState(false);
  const [isShowErrors, showErrors] = useState(false);
  const [tableVariablesInTemp, setTableVariables] = useState([]);
  const [missingVarList, setMissingVarList] = useState([]);
  const [messagesStatus, setMessagesStatus] = useState(undefined);
  const [partialSuccess, setPartialSuccess] = useState(false);
  let generatePdfJson = [];
  let errorMessages = errorMessage;
  let tableJsonData = [];
  let isAllTableVarAvl = [];
  const { Step } = Steps;
  const windowSize = window.innerWidth;
  const isMailRoomModuleEnabled = checkUserAccess('client', ['MAILROOMADMIN', 'MAILROOMCLIENT']);
  let publishedType = publishedMessageType?.replace(/\//g, '');
  let messageType =
    publishedType === 'publishedMessages'
      ? 'whatsapp'
      : publishedType === 'publishedCallMessages'
      ? 'call'
      : 'sms';
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: isMailTemplates
      ? emailAnimationData
      : isPublishedMessages
      ? messageType === 'call'
        ? callAnimationData
        : messageType === 'whatsapp'
        ? whatsappAnimationData
        : messageType === 'sms'
        ? smsAnimationData
        : ''
      : pdfAnimationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };
  let myIntervalId = useRef(null);

  useEffect(() => {
    (async () => {
      if (isMailRoomModuleEnabled) {
        let tagsData = await getTagsList();
        if (tagsData && tagsData.data) {
          setTagsData(tagsData?.data);
        }
      }
    })();
  }, [isMailRoomModuleEnabled]);

  useEffect(() => {
    (async () => {
      setCurrentStep(0);
      setReqMailStatus([]);
      setIsLoading(page === 1 && true);
      if (isPublishedMessages) {
        let shortMsgPayload = {
          messageType: messageType,
          page: page,
          limit: windowSize > 1440 && windowSize < 2560 ? 12 : 9,
        };
        if (searchVal) {
          shortMsgPayload.name = searchVal;
        }
        if (searchTag) {
          shortMsgPayload.tags = searchTag;
        }
        if (filterByCateg) {
          shortMsgPayload.categoryIds = filterByCateg;
        }
        let messageResp = await getAllPublishedMessages(shortMsgPayload);
        if (messageResp && messageResp.data) {
          let templateData;
          if (shortMsgPayload.page > 1) {
            templateData = templatesList.concat(messageResp.data);
          } else {
            templateData = messageResp.data;
          }
          setTemplatesList(templateData);
          setTotalTemplates(messageResp.dataCount);
        }
      } else {
        let payload = {
          page: page,
          channel: isMailTemplates ? 'email' : 'print',
          limit: windowSize > 1440 && windowSize < 2560 ? 12 : 9,
        };
        if (searchVal) {
          payload.name = searchVal;
        }
        if (searchTag) {
          payload.tags = searchTag;
        }
        if (filterByCateg) {
          payload.categoryIds = filterByCateg;
        }
        let response = await getAllPublishedtemplate(payload);
        if (response && response.data) {
          let templateData;
          if (payload.page > 1) {
            templateData = templatesList.concat(response.data);
          } else {
            templateData = response.data;
          }
          setTemplatesList(templateData);
          setTotalTemplates(response.dataCount);
        }
      }
      tempCategories.length > 0 && setIsLoading(false);
    })();
  }, [
    loginVisible,
    page,
    filterByCateg,
    searchVal,
    searchTag,
    isMailTemplates,
    isPublishedMessages,
    publishedMessageType,
  ]);

  useEffect(() => {
    setIsLoading(true);
    if (tempCategories.length > 0) {
      setIsLoading(false);
    }
  }, [tempCategories]);

  useEffect(() => {
    if (reqMailId.length > 0 && isModalVisible && downloadedZip) {
      getEmailReqStatus(downloadedZip);
    } else if (!isModalVisible) {
      clearInterval(myIntervalId.current);
    }
  }, [reqMailId, isModalVisible, downloadedZip]);

  const hasProcessingStatus = allItems => {
    let pending = ['Processing', 'Inqueue', 'File Attached'];
    for (const item of allItems) {
      if (pending.includes(item.status)) {
        return true;
      }
    }
    return false;
  };

  let getEmailReqStatus = async () => {
    let allMailReqStatus = reqMailId.map(id => ({ id, status: 'Processing' }));

    let counter = 0;

    myIntervalId.current = setInterval(async () => {
      let pending = ['Processing', 'Inqueue', 'File Attached'];
      let currentItem = allMailReqStatus[counter];
      if (pending.includes(currentItem.status)) {
        let response = await getEmailAuditDetails(currentItem.id);
        if (response?.data?.details?.length > 0) {
          let reqDetails = response?.data?.details;
          let reqStatus = reqDetails[reqDetails.length - 1];
          currentItem.status = reqStatus?.statusCode;

          setReqMailStatus(prevData =>
            prevData.map(item =>
              item.id === currentItem.id ? { ...item, status: reqStatus?.statusCode } : item,
            ),
          );
        }
      }
      counter++;

      if (counter === allMailReqStatus.length) {
        if (!hasProcessingStatus(allMailReqStatus)) {
          clearInterval(myIntervalId.current);
        } else {
          counter = 0;
        }
      }
    }, 1500);
  };

  const [isRepeatedBlocks, isChartBlock] = useMemo(() => {
    if (selectedTemplate && selectedTemplate.variables.length > 0) {
      const hasRepeatedBlocks = selectedTemplate.variables.some(
        variable => variable.type === VARIABLE_TYPE.OBJECT,
      );
      const hasChartBlock = selectedTemplate.variables.some(
        variable => variable.type === VARIABLE_TYPE.CHART_OBJECT,
      );
      return [hasRepeatedBlocks, hasChartBlock];
    }
    return [false, false];
  }, [selectedTemplate]);

  const beforeUploadEmailTransaction = (file) => {
    if (!checkFileFormat(file.name)) {
      message.error(t(TRANSACTIONS.WRONG_FILE_UPLOADED_ERROR_MESSAGE.key, TRANSACTIONS.WRONG_FILE_UPLOADED_ERROR_MESSAGE.value));
      return;
    };

    const reader = new FileReader();
    reader.onload = async event => {
      const binaryString = event.target.result;
      const workbook = XLSX.read(binaryString, { type: 'binary' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      // Assuming the first row contains headers
      const headers = data[0];
      const subHeaders = isRepeatedBlocks || isChartBlock ? data[1] : undefined;
      const rows = data.slice(isRepeatedBlocks || isChartBlock ? 2 : 1); // Exclude header row
      let dataIndex;

      if(rows.flat().length < 1) {
        message.error(t(TRANSACTIONS.EMPTY_DATE_ERROR_MESSAGE.key, TRANSACTIONS.EMPTY_DATE_ERROR_MESSAGE.value));
        return;
      }
      const hasInvalidEmailId = rows.some((row) => {
        return row.some((cell, cellIndex) => {
          if (headers[cellIndex] === 'To Email Address') {
            const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!regex.test(cell)) {
              message.error(`${t(EMAIL_TRANSACTIONS.INVALID_EMAIL_ADDRESS_ERROR_MESSAGE.key, EMAIL_TRANSACTIONS.INVALID_EMAIL_ADDRESS_ERROR_MESSAGE.value)}: ${cell}`);
              return true;
            }
          }
          return false;
        });
      });
      
      if(hasInvalidEmailId) {
        return;
      }

      setIsUploading(true);
  
      const excelData = rows
        .flatMap(row => {
          const rowData = [];
          let obj = {};
          row.forEach((cellData, index) => {
            const cell = cellData.toString();
            if (headers[index] === 'id') {
              dataIndex = cell;
              obj = {};
            }
            if (headers[index] && (subHeaders === undefined || subHeaders[index] === undefined)) {
              const isListOfStrings = selectedTemplate.variables.some(
                variable =>
                  variable.name === headers[index] &&
                  variable.type === VARIABLE_TYPE.LIST_STRING,
                );
              const isDate = selectedTemplate.variables.some(
                variable =>
                  variable.name === headers[index] &&
                  variable.type === VARIABLE_TYPE.DATE,
                );
                obj[headers[index]] = isListOfStrings ? cell.split(',') : isDate ? convertExcelSerialDate(cell) : cell;
              }
              if (headers[index] && subHeaders !== undefined && subHeaders[index] !== undefined) {
                if (!obj[headers[index]]) {
                  obj[headers[index]] = {};
                }
                const isListOfStrings = selectedTemplate.variables.some(
                  variable =>
                    variable.name === headers[index] &&
                    variable.type === VARIABLE_TYPE.OBJECT &&
                    variable.content.some(
                      subVar =>
                        subVar.name === subHeaders[index] &&
                        subVar.type === VARIABLE_TYPE.LIST_STRING,
                    ),
                );
                const isDate = selectedTemplate.variables.some(
                  variable =>
                    variable.name === headers[index] &&
                    variable.type === VARIABLE_TYPE.OBJECT &&
                    variable.content.some(
                      subVar =>
                        subVar.name === subHeaders[index] &&
                        subVar.type === 'date',
                    ),
                );              
                obj['id'] = dataIndex;
                obj[headers[index]][subHeaders[index]] = isListOfStrings ? cell.split(',') : isDate ? convertExcelSerialDate(cell) : cell;
              }
            });
            rowData.push(obj);
            return rowData;
          })
          .filter(row => Object.keys(row).length !== 0);
  
        const payload =
          isRepeatedBlocks || isChartBlock
            ? generateRepeatedBloackPayload(excelData)
            : generatePayload(excelData);
  
        setIsUploading(false);
        setIsgeneratingPdf(true);
        setIsModalVisible(true);
        downloadZipfile(payload);
      };    
    reader.readAsBinaryString(file);
    return false; // Prevent default upload behavior
  };

  const generateRepeatedBloackPayload = excelData => {
    let groupedData = {};
    excelData.forEach(item => {
      let { id, 'To Email Address': toEmailAddress, 'Attachment Password': attachmentPassword, BCC, CC, ...rest } = item;
      if (!groupedData[id]) {
        groupedData[id] = {
          targetUrl:`${URL.BASE_URL}testWebHook`,
          htmlFileName: null,
          caseObject: null,
          mailTemplateId: selectedTemplate.id,
          variables: {},
          to: [toEmailAddress],
          bcc: BCC ? [BCC] : [],
          cc: CC ? [CC] : [],
        };
        if(attachmentPassword) {
          groupedData[id].attachmentPassword = attachmentPassword;
        }
      }

      for (let key in rest) {
        const isChartObject = selectedTemplate.variables.some(
          variable => variable.name === key && variable.type === VARIABLE_TYPE.CHART_OBJECT,
        );
        if (typeof rest[key] === VARIABLE_TYPE.OBJECT && !Array.isArray(rest[key])) {
          if (!groupedData[id]['variables'][key]) {
            groupedData[id]['variables'][key] = [];
          }
          groupedData[id]['variables'][key].push(rest[key]);
        } else if (typeof rest[key] === VARIABLE_TYPE.OBJECT && isChartObject) {
          if (!groupedData[id]['variables'][key]) {
            groupedData[id]['variables'][key] = [];
          }
          groupedData[id]['variables'][key].push(rest[key]);
        } else {
          groupedData[id]['variables'][key] = rest[key];
        }
      }
    });
    // Transform groupedData object into an array of objects
    let result = Object.keys(groupedData).map(key => {
      let obj = groupedData[key];
      return obj;
    });
    return result;
  };

  const generatePayload = excelData =>
    excelData.map(obj => {
      let { 'To Email Address': toEmailAddress, 'Attachment Password': attachmentPassword, BCC, CC, ...rest } = obj;
      const payload = {
        targetUrl:`${URL.BASE_URL}testWebHook`,
        htmlFileName: null,
        caseObject: null,
        mailTemplateId: selectedTemplate.id,
        variables: { ...rest },
        to: [toEmailAddress],
        bcc: BCC ? [BCC] : [],
        cc: CC ? [CC] : [],
      };
      if(attachmentPassword) {
        payload.attachmentPassword = attachmentPassword;
      }
      return payload;
    });

  const apiArrayToExcel = async (usedVariables, template) => {
    let jsonObj = [];
    let tableVariables = [];
    let tableJsonObj = [];
    let item = {};
    usedVariables.map(eachVar => eachVar.type === 'table' && tableVariables.push([eachVar]));
    if (tableVariables.length > 0) {
      setTableVariables(tableVariables);
      item['value'] = 'Sl.No';
      item['fontWeight'] = 'bold';
      jsonObj.push(item);
    }
    if (isMailTemplates) {
      const wb = XLSX.utils.book_new();
    // Create a worksheet
    const ws = XLSX.utils.aoa_to_sheet([]);
    // Add data to worksheet
    let col = 0;
    if (isRepeatedBlocks || isChartBlock) {
      XLSX.utils.sheet_add_aoa(ws, [['id']], {
        origin: { r: 0, c: col++ },
      });
    }
    const header = ['To Email Address', 'BCC', 'CC'];
    if(template.passwordProtected) {
      header.push('Attachment Password');
    }
    header.forEach(item => {
      XLSX.utils.sheet_add_aoa(ws, [[item]], {
        origin: { r: 0, c: col },
      });
      col++;
    })
    // Add main headers and subheaders
    usedVariables.forEach(item => {  
      if (item.type.toLowerCase() === VARIABLE_TYPE.STRING || item.type === VARIABLE_TYPE.LIST_STRING || item.type === VARIABLE_TYPE.DATE) {       
        XLSX.utils.sheet_add_aoa(ws, [[item.name]], {
          origin: { r: 0, c: col },
        });
        col++;
      } else if (item.type === VARIABLE_TYPE.OBJECT || item.type === VARIABLE_TYPE.CHART_OBJECT) {
        item.content.forEach(subItem => {
          XLSX.utils.sheet_add_aoa(ws, [[item.name]], {
            origin: { r: 0, c: col },
          });
          XLSX.utils.sheet_add_aoa(ws, [[subItem.name]], {
            origin: { r: 1, c: col },
          });

          col++;
        });
      }
    });
    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    // Generate Excel file
    XLSX.writeFile(wb, `${selectedTemplate.name}.xlsx`);
    return;
    } else if (isPublishedMessages) {
      for (var n = 1; n <= 2; n++) {
        item = {};
        item['value'] = n === 1 ? 'Country code without +' : n === 2 ? 'To Mobile Number' : '';
        item['fontWeight'] = 'bold';
        jsonObj.push(item);
      }
    }
    if (!isMailTemplates && usedVariables.length > 0) {
      let variablesInDoc = globalVariables?.filter(globalVar =>
        usedVariables.some(docVar => globalVar.placeHolderText === docVar.name),
      );
      let booleanVariables = usedVariables?.filter(usedVar => usedVar.type === 'boolean');
      if (booleanVariables && booleanVariables?.length > 0) {
        booleanVariables.map(boolVar => {
          item = {};
          item['value'] = boolVar.name;
          item['fontWeight'] = 'bold';
          jsonObj.push(item);
        });
      }
      variablesInDoc.map(variable => {
        item = {};
        if (variable.type === 'ListString') {
          for (var i = 1; i < variable.count + 1; i++) {
            item = {};
            item['value'] = variable.placeHolderText + i;
            item['fontWeight'] = 'bold';
            jsonObj.push(item);
          }
        } else {
          item['value'] = variable.placeHolderText;
          item['fontWeight'] = 'bold';
          jsonObj.push(item);
        }
      });
    }
    if (isMailRoomModuleEnabled && tagsData && !isMailTemplates && !isPublishedMessages) {
      if (tagsData.length > 0) {
        item = {};
        item['value'] = 'Printable';
        item['fontWeight'] = 'bold';
        jsonObj.push(item);
        for (var i = 0; i < tagsData.length; i++) {
          item = {};
          item['value'] = tagsData[i].tagName;
          item['fontWeight'] = 'bold';
          jsonObj.push(item);
        }
      }
    }
    if (tableVariables.length > 0) {
      let tableItem = {};
      let allTableVar = [];
      let eachTableVar = [];
      tableVariables.map(tableVar => {
        eachTableVar = [];
        tableItem = {};
        tableItem['value'] = 'Sl.No';
        tableItem['fontWeight'] = 'bold';
        eachTableVar.push(tableItem);
        allTableVar.push(tableVar[0].name);
        tableVar[0].keytoMap.map(eachVar => {
          let isListString = globalVariables?.filter(variable => {
            return variable.placeHolderText === eachVar.keyToMap;
          });
          if (isListString?.length > 0) {
            isListString = isListString[0];
            if (isListString.type === 'ListString') {
              for (var i = 1; i < isListString.count + 1; i++) {
                tableItem = {};
                tableItem['value'] = isListString.placeHolderText + i;
                tableItem['fontWeight'] = 'bold';
                eachTableVar.push(tableItem);
              }
            } else {
              tableItem = {};
              tableItem['value'] = eachVar.keyToMap;
              tableItem['fontWeight'] = 'bold';
              eachTableVar.push(tableItem);
            }
          } else {
            tableItem = {};
            tableItem['value'] = eachVar.keyToMap;
            tableItem['fontWeight'] = 'bold';
            eachTableVar.push(tableItem);
          }
        });
        tableJsonObj.push([eachTableVar]);
      });
      await writeXlsxFile([[jsonObj], ...tableJsonObj], {
        fileName: `${template.name}.xlsx`,
        sheets: ['variables', ...allTableVar],
      });
    } else {
      await writeXlsxFile([jsonObj], {
        fileName: `${template.name}.xlsx`,
      });
    }
  };

  console.log('setIsUploadFailed',isUploadFailed)
  const uploadedExcelToJson = (rows, usedVariables, allSheetNames, eachSheetName) => {
    setIsUploading(true);
    let errMsg = null;
    setErrorMessage(null);
    let eachListVar = [];
    if (rows.length > 1) {
      let varTitles = rows[0];
      let myTableVar = undefined;
      let isTableVarAvl = tableVariablesInTemp.length > 0;
      let isTableVarSheet = tableVariablesInTemp.map(
        tableVar => tableVar[0].name === eachSheetName,
      );
      isTableVarSheet = isTableVarSheet.includes(true);
      let missingVar = [];
      if (isTableVarSheet) {
        isAllTableVarAvl.push(eachSheetName);
        myTableVar = tableVariablesInTemp.map(tableVar => {
          if (tableVar[0].name === eachSheetName) {
            return tableVar[0].keytoMap;
          }
        });
        myTableVar = myTableVar?.filter(element => {
          return element !== undefined;
        });
        myTableVar = myTableVar?.length > 0 && myTableVar[0];
        if (isTableVarSheet && myTableVar && myTableVar.length > 0) {
          let variablesInDoc = globalVariables?.filter(globalVar =>
            myTableVar?.some(docVar => globalVar.placeHolderText === docVar?.keyToMap),
          );
          usedVariables = variablesInDoc;
          let varInTable;
          usedVariables.map(usedVar => (varInTable = usedVar.keyToMap));
          let missingTableVar = varInTable?.filter(item => varTitles.indexOf(item) == -1);
          if (missingTableVar?.length > 0) {
            missingVar = [{ name: missingVar[0] }];
          }
        }
      }
      missingVar = usedVariables
        .filter(usedVar => {
          if (usedVar.type === 'ListString') {
            let myList = {};
            for (let i = 1; i <= usedVar.count; i++) {
              if (
                varTitles.includes((isTableVarSheet ? usedVar.placeHolderText : usedVar.name) + i)
              ) {
                myList.varName = isTableVarSheet ? usedVar.placeHolderText : usedVar.name;
                myList.totalCount = usedVar.count;
                myList.avlCount = i;
              } else {
                if (i < 2) {
                  //// multi value variable should have mininum ?? values --> given 1
                  return true;
                }
              }
            }
            eachListVar.push(myList);
          } else if (usedVar.type === 'table') {
            return !allSheetNames?.includes(usedVar.name);
          } else {
            return !varTitles.includes(isTableVarSheet ? usedVar.placeHolderText : usedVar.name);
          }
        })
        .map(usedVar => {
          return usedVar;
        });
      missingVar = missingVar?.filter(
        (li, idx, self) => self.map(itm => itm.name).indexOf(li.name) === idx,
      );
      if (missingVar?.length === 0) {
        let jsonData = [];
        let tableData = [];
        let listData = [];
        let jsonObj = [];
        let tagsObj = [];
        let excelToArrayData = {};
        let validSerialNo;
        for (var x = 1; x < rows.length; x++) {
          let phoneNum;
          let countryCode;
          if (rows[x][0] !== null && rows[x][0] !== undefined) {
            validSerialNo = rows[x][0];
          }
          if (isMailTemplates && !varTitles.includes('To Email Address')) {
            setIsUploading(false);
            setErrorMessage(t(`EMAIL_TRANSACTIONS:${EMAIL_TRANSACTIONS.TO_EMAIL_MISSING_ERROR_MESSAGE.key}`, EMAIL_TRANSACTIONS.TO_EMAIL_MISSING_ERROR_MESSAGE.value));
            showErrors(true);
            errMsg = t(`EMAIL_TRANSACTIONS:${EMAIL_TRANSACTIONS.TO_EMAIL_MISSING_ERROR_MESSAGE.key}`, EMAIL_TRANSACTIONS.TO_EMAIL_MISSING_ERROR_MESSAGE.value);
          } else if (isPublishedMessages && !varTitles.includes('To Mobile Number')) {
            setIsUploading(false);
            setErrorMessage(t(TRANSACTIONS.TO_MOBILE_MISSING_ERROR_MESSAGE.key, TRANSACTIONS.TO_MOBILE_MISSING_ERROR_MESSAGE.value));
            showErrors(true);
            errMsg = t(TRANSACTIONS.TO_MOBILE_MISSING_ERROR_MESSAGE.key, TRANSACTIONS.TO_MOBILE_MISSING_ERROR_MESSAGE.value);
          }
          if (isTableVarAvl && !varTitles.includes('Sl.No')) {
            setIsUploading(false);
            setErrorMessage(t(TRANSACTIONS.SERIAL_NUMBER_MISSING_ERROR_MESSAGE.key, TRANSACTIONS.SERIAL_NUMBER_MISSING_ERROR_MESSAGE.value));
            showErrors(true);
            errMsg = t(TRANSACTIONS.SERIAL_NUMBER_MISSING_ERROR_MESSAGE.key, TRANSACTIONS.SERIAL_NUMBER_MISSING_ERROR_MESSAGE.value);
          } else {
            jsonObj = [];
            tagsObj = [];
            excelToArrayData = {};
            if (!isTableVarSheet) {
              if (isMailTemplates) {
                excelToArrayData.mailTemplateId = selectedTemplate?.templateid;
                if (
                  selectedTemplate.passwordProtected &&
                  !varTitles.includes('Attachment Password')
                ) {
                  setIsUploading(false);
                  setErrorMessage(t(TRANSACTIONS.ATTACHMENT_PASSWORD_MISSING_ERROR_MESSAGE.key, TRANSACTIONS.ATTACHMENT_PASSWORD_MISSING_ERROR_MESSAGE.value));
                  showErrors(true);
                  errMsg = t(TRANSACTIONS.ATTACHMENT_PASSWORD_MISSING_ERROR_MESSAGE.key, TRANSACTIONS.ATTACHMENT_PASSWORD_MISSING_ERROR_MESSAGE.value);
                }
              } else if (isPublishedMessages) {
                excelToArrayData.messageId = selectedTemplate?.messageId;
              } else {
                excelToArrayData.templateId = selectedTemplate?.templateid;
              }
            }
            for (var y = 0; y < rows[x].length + 1; y++) {
              let rowData = rows[x];
              if (isMailTemplates) {
                excelToArrayData.targetUrl = `${URL.BASE_URL}testWebHook`;
                excelToArrayData.htmlFileName = null;
                excelToArrayData.caseObject = null;
                if (varTitles[y] === 'Attachment Password') {
                  if (selectedTemplate.passwordProtected && (rowData[y] === '' || !rowData[y])) {
                    setIsUploading(false);
                    setErrorMessage(
                      t(TRANSACTIONS.ATTACHMENT_PASSWORD_REQUIRED_ERROR_MESSAGE.key, TRANSACTIONS.ATTACHMENT_PASSWORD_REQUIRED_ERROR_MESSAGE.value),
                    );
                    showErrors(true);
                    errMsg =
                    t(TRANSACTIONS.ATTACHMENT_PASSWORD_REQUIRED_ERROR_MESSAGE.key, TRANSACTIONS.ATTACHMENT_PASSWORD_REQUIRED_ERROR_MESSAGE.value);
                  }
                  excelToArrayData.attachmentPassword = rowData[y];
                }
                if (varTitles[y] === 'To Email Address') {
                  if (rowData[y]) {
                    let allEmailAddress = rowData[y]?.split(',');
                    excelToArrayData.to = allEmailAddress;
                  } else {
                    setIsUploading(false);
                    setErrorMessage(t(`EMAIL_TRANSACTIONS:${EMAIL_TRANSACTIONS.TO_EMAIL_MISSING_ERROR_MESSAGE.key}`, EMAIL_TRANSACTIONS.TO_EMAIL_MISSING_ERROR_MESSAGE.value));
                    showErrors(true);
                    errMsg = t(`EMAIL_TRANSACTIONS:${EMAIL_TRANSACTIONS.TO_EMAIL_MISSING_ERROR_MESSAGE.key}`, EMAIL_TRANSACTIONS.TO_EMAIL_MISSING_ERROR_MESSAGE.value);
                  }
                } else if (varTitles[y] === 'BCC') {
                  excelToArrayData.bcc = rowData[y] ? [rowData[y]] : [];
                } else if (varTitles[y] === 'CC') {
                  excelToArrayData.cc = rowData[y] ? [rowData[y]] : [];
                }
              } else if (isPublishedMessages) {
                if (varTitles[y] === 'To Mobile Number') {
                  phoneNum = rowData[y];
                  if (!phoneNum) {
                    setIsUploading(false);
                    setErrorMessage(t(TRANSACTIONS.TO_MOBILE_MISSING_ERROR_MESSAGE.key, TRANSACTIONS.TO_MOBILE_MISSING_ERROR_MESSAGE.value) + ' - ' + x);
                    showErrors(true);
                    errMsg = t(TRANSACTIONS.TO_MOBILE_MISSING_ERROR_MESSAGE.key, TRANSACTIONS.TO_MOBILE_MISSING_ERROR_MESSAGE.value)  + ' - ' + x;
                  }
                }
                if (varTitles[y] === 'Country code without +') {
                  countryCode = rowData[y];
                  if (!countryCode) {
                    setIsUploading(false);
                    setErrorMessage(t(TRANSACTIONS.MOBILE_COUNTRY_CODE_MISSING_ERROR_MESSAGE.key, TRANSACTIONS.MOBILE_COUNTRY_CODE_MISSING_ERROR_MESSAGE.value) + ' - ' + x);
                    showErrors(true);
                    errMsg = t(TRANSACTIONS.MOBILE_COUNTRY_CODE_MISSING_ERROR_MESSAGE.key, TRANSACTIONS.MOBILE_COUNTRY_CODE_MISSING_ERROR_MESSAGE.value)  + ' - ' + x;
                  }
                }
                if (phoneNum && countryCode) {
                  var plusRegex = /[+]/;
                  let userNumber = `${countryCode}` + `${phoneNum}`;
                  if (plusRegex.test(userNumber)) {
                    excelToArrayData.toNumber = userNumber;
                  } else {
                    excelToArrayData.toNumber = `+${userNumber}`;
                  }
                }
              }
              if (isMailRoomModuleEnabled && !isTableVarSheet && !isMailTemplates && !isPublishedMessages) {
                let tagValueAvl = tagsData?.filter(tag => {
                  return varTitles.includes(tag.tagName);
                });
                if (tagsData?.length > 0 && tagValueAvl?.length === 0 && !isTableVarSheet) {
                  setIsUploading(false);
                  setErrorMessage(t(TRANSACTIONS.TAG_VALUE_MISSING_ERROR_MESSAGE.key, TRANSACTIONS.TAG_VALUE_MISSING_ERROR_MESSAGE.value));
                  showErrors(true);
                  errMsg = t(TRANSACTIONS.TAG_VALUE_MISSING_ERROR_MESSAGE.key, TRANSACTIONS.TAG_VALUE_MISSING_ERROR_MESSAGE.value);
                } else {
                  if (varTitles[y] === 'Printable') {
                    if (rowData[y] !== null && rowData[y] !== undefined && rowData[y] !== '') {
                      if (typeof rowData[y] === 'boolean') {
                        excelToArrayData.printable = rowData[y];
                      } else {
                        setErrorMessage(t(TRANSACTIONS.INVALID_TYPE_IN_PRINTABLE_COLUMN_ERROR_MESSAGE.key, { x: x }));
                        showErrors(true);
                        errMsg = (TRANSACTIONS.INVALID_TYPE_IN_PRINTABLE_COLUMN_ERROR_MESSAGE.key, { x: x })
                        setIsUploading(false);
                        setDownloadZip(null);
                      }
                    }
                  }
                  tagsData &&
                    tagsData.map(eachTag => {
                      if (varTitles[y] === eachTag.tagName) {
                        let item = {};
                        item['tagName'] = eachTag.tagName;
                        item['tagValue'] = rowData[y];
                        tagsObj.push(item);
                      }
                    });
                  excelToArrayData.tagInfo = tagsObj;
                }
              }
              usedVariables.map(usedVar => {
                let item = {};
                if ((isTableVarSheet ? usedVar.placeHolderText : usedVar.name) === varTitles[y]) {
                  item['name'] = varTitles[y];
                  item['value'] = rowData[y] ? rowData[y] : '';
                  if (usedVar.type === 'Date') {
                    if (rowData[y] !== null && rowData[y] !== undefined && rowData[y] !== '') {
                      var regex = /(0[1-9]|1[0-9]|2[0-9]|3(0|1))-(0[1-9]|1[0-2])-\d{4}/;
                      var match = regex.test(rowData[y]);
                      if (match) {
                        item['value'] = rowData[y] ? rowData[y] : '';
                      } else {
                        var date = new Date(rowData[y]),
                          mnth = ('0' + (date.getMonth() + 1)).slice(-2),
                          day = ('0' + date.getDate()).slice(-2);
                        let newDate = [day, mnth, date.getFullYear()].join('-');
                        match = regex.test(newDate);
                        if (match && typeof rowData[y] !== 'number') {
                          item['value'] = newDate;
                        } else {
                          setErrorMessage(t(TRANSACTIONS.INVALID_DATE_FORMAT_ERROR_MESSAGE.key, { x: x }));
                          showErrors(true);
                          errMsg = t(TRANSACTIONS.INVALID_DATE_FORMAT_ERROR_MESSAGE.key, { x: x });
                          setIsUploading(false);
                          setDownloadZip(null);
                        }
                      }
                    } else {
                      setErrorMessage(t(TRANSACTIONS.EMPTY_DATE_ERROR_MESSAGE.key, { x: x }));
                      showErrors(true);
                      errMsg = t(TRANSACTIONS.EMPTY_DATE_ERROR_MESSAGE.key, { x: x });
                      setIsUploading(false);
                      setDownloadZip(null);
                    }
                  } else if (usedVar.type === 'boolean') {
                    if (
                      rowData[y] !== null &&
                      rowData[y] !== undefined &&
                      rowData[y] !== '' &&
                      typeof rowData[y] === 'boolean'
                    ) {
                      item['value'] = rowData[y];
                    } else {
                      setErrorMessage(t(TRANSACTIONS.BOOLEAN_TYPE_REQUIRED_ERROR_MESSAGE.key, { x: x }));
                      showErrors(true);
                      errMsg = t(TRANSACTIONS.PLACEHOLDER_TEXT_BOOLEAN_TYPE_ERROR_MESSAGE.key, { placeholderText: usedVar.placeHolderText });
                      setIsUploading(false);
                      setDownloadZip(null);
                    }
                  }
                  jsonObj.push(item);
                  excelToArrayData.variables = jsonObj;
                } else if (usedVar.type === 'ListString') {
                  eachListVar = eachListVar?.filter(
                    (listVar, index, self) =>
                      index === self.findIndex(t => t.varName === listVar.varName),
                  );
                  let filteredVar = eachListVar?.filter(
                    eachList =>
                      eachList.varName ===
                      (isTableVarSheet ? usedVar.placeHolderText : usedVar.name),
                  );
                  if (filteredVar && filteredVar.length > 0) {
                    filteredVar = filteredVar[0];
                  }
                  for (var i = 1; i < usedVar.count + 1; i++) {
                    if (
                      (isTableVarSheet ? usedVar.placeHolderText : usedVar.name) + i ===
                      varTitles[y]
                    ) {
                      listData.push(rowData[y]);
                      if (listData.length === filteredVar.avlCount) {
                        listData = listData.filter(
                          el => el !== null && el !== undefined && el !== '',
                        );
                        item['name'] = isTableVarSheet ? usedVar.placeHolderText : usedVar.name;
                        item['value'] = listData;
                        jsonObj.push(item);
                        excelToArrayData.variables = jsonObj;
                        listData = [];
                      }
                    }
                  }
                }
              });
            }
            excelToArrayData.variables = excelToArrayData.variables?.filter(
              (excelVar, index, self) => index === self.findIndex(t => t.name === excelVar.name),
            );
            if (isMailRoomModuleEnabled && excelToArrayData.printable && !isMailTemplates && !isPublishedMessages) {
              let isTagListEmpty = excelToArrayData.tagInfo.every(info => {
                return info.tagValue === null;
              });
              if (tagsData && isTagListEmpty) {
                setIsUploading(false);
                setErrorMessage(
                  t(TRANSACTIONS.TAG_VALUE_MISSING_ERROR_MESSAGE.key, TRANSACTIONS.TAG_VALUE_MISSING_ERROR_MESSAGE.value) + t(TRANSACTIONS.TAG_VALUE_MISSING_DESCRIPTION_ERROR_MESSAGE.key, TRANSACTIONS.TAG_VALUE_MISSING_DESCRIPTION_ERROR_MESSAGE.value)
                );
                errMsg = t(TRANSACTIONS.TAG_VALUE_MISSING_ERROR_MESSAGE.key, TRANSACTIONS.TAG_VALUE_MISSING_ERROR_MESSAGE.value);
                showErrors(true);
              }
            }
            if (!isTableVarSheet) {
              if (isTableVarAvl) {
                excelToArrayData.serialNo = validSerialNo;
              }
              generatePdfJson.push(excelToArrayData);
            } else {
              excelToArrayData.slNo = validSerialNo;
              excelToArrayData.tableName = eachSheetName;
              tableJsonData.push(excelToArrayData);
              var groupedBySerialNum = {};
              for (var key in tableJsonData) {
                var serialNum = tableJsonData[key].slNo;
                if (!groupedBySerialNum[serialNum]) {
                  groupedBySerialNum[serialNum] = [];
                }
                groupedBySerialNum[serialNum].push(tableJsonData[key]);
              }
              groupedBySerialNum = Object.values(groupedBySerialNum);
              var groupedByTableName = [];
              for (var a = 0; a < groupedBySerialNum.length; a++) {
                let groupedBySlNum = groupedBySerialNum[a];
                let serialNo;
                let newData = [...new Set(groupedBySlNum.map(d => d.tableName))].map(tableName => {
                  let allTableVar = groupedBySlNum
                    .filter(d => d.tableName === tableName)
                    .map(d => {
                      serialNo = d.slNo;
                      let eachRowItem = {};
                      d.variables.map(vari => {
                        let tableItem = {};
                        tableItem[vari.name] = vari.value;
                        eachRowItem = Object.assign(eachRowItem, tableItem);
                      });
                      return eachRowItem;
                    });
                  let returnData = {
                    name: tableName,
                    value: allTableVar,
                  };
                  return returnData;
                });
                let grpByTableData = {};
                grpByTableData.serialNum = serialNo;
                grpByTableData.variables = newData;
                groupedByTableName.push(grpByTableData);
              }
            }
            jsonData.push(excelToArrayData);
          }
        }
        let groupedByTableNameVar =
          groupedByTableName?.length > 0 && groupedByTableName[0]?.variables;
        if (
          generatePdfJson?.length > 0 &&
          groupedByTableName?.length > 0 &&
          groupedByTableNameVar?.length === tableVariablesInTemp.length
        ) {
          generatePdfJson.map(pdfJson =>
            groupedByTableName.map(byTableName => {
              if (pdfJson.serialNo === byTableName.serialNum) {
                // delete pdfJson.serialNo;
                pdfJson.variables = pdfJson.variables?.filter(el => el.name != undefined);
                pdfJson.variables = pdfJson.variables?.filter(
                  (arr, index, self) => index === self.findIndex(t => t.name === arr.name),
                );
                let finalTableJson =
                  pdfJson?.variables?.length > 0
                    ? pdfJson?.variables?.concat(byTableName.variables)
                    : byTableName.variables;
                console.log('');
                pdfJson.variables = finalTableJson;
              }
            }),
          );
        }
        if (
          !errMsg &&
          (!isTableVarAvl ||
            (isAllTableVarAvl.length === tableVariablesInTemp.length && !errorMessages))
        ) {
          setIsModalVisible(true);
          setDownloadZip(true);
          setIsUploading(false);
          downloadZipfile(isTableVarAvl ? generatePdfJson : jsonData);
        }
      } else {
        setIsUploading(false);
        let missedArray = [];
        if (missingVar) {
          setMissingVarList(missingVar);
          missingVar.map(missedVar => {
            missedArray.push(missedVar.name);
            setErrorMessage(
              `${missedVar.length > 1 
                ? 
                t(TRANSACTIONS.TEMPLATE_VARIABLES_TITLE.key, TRANSACTIONS.TEMPLATE_VARIABLES_TITLE.value) 
                : 
                t(TRANSACTIONS.TEMPLATE_VARIABLE_MISSING_ERROR_MESSAGE.key, { missedArray: missedArray })}`,
            );
            showErrors(true);
          });
        }
      }
    } else {
      setIsUploading(false);
      setErrorMessage(
        isMailTemplates
          ? t(EMAIL_TRANSACTIONS.UPLOADED_EMAIL_EMPTY_FILE_ERROR_MESSAGE.key, EMAIL_TRANSACTIONS.UPLOADED_EMAIL_EMPTY_FILE_ERROR_MESSAGE.value)
          : isPublishedMessages
          ? t(MESSAGE_TRANSACTIONS.UPLOADED_SMS_EMPTY_FILE_ERROR_MESSAGE.key, MESSAGE_TRANSACTIONS.UPLOADED_SMS_EMPTY_FILE_ERROR_MESSAGE.value)
          : t(PDF_TRANSACTIONS.UPLOADED_PDF_EMPTY_FILE_ERROR_MESSAGE.key, PDF_TRANSACTIONS.UPLOADED_PDF_EMPTY_FILE_ERROR_MESSAGE.value),
      );
      showErrors(true);
    }
  };

  const getTemplateDetails = async (type, val, allSheetNames, eachSheetName, noVarTemp) => {
    !eachSheetName && setErrorMessage(null);
    let usedVariables = selectedTemplate?.variables || noVarTemp?.variables;
    if (!isMailTemplates && !isPublishedMessages && usedVariables?.length === 0) {
      setIsViewVarDetails(true);
      setIsgeneratingPdf(true);
      let payload = [{
        templateId: selectedTemplate?.templateid || noVarTemp?.templateid,
        variables: [],
      }];
      let downloadedResp = await uploadDataSet(null, payload);
      if (downloadedResp && downloadedResp.data) {
        window.open(downloadedResp.data.uri);
        setIsgeneratingPdf(false); 
      } else {
        setIsgeneratingPdf(false);
        setIsViewVarDetails(false);
        if (!downloadedResp) {
          message.error(t(PDF_TRANSACTIONS.TIME_OUT_ERROR_MESSAGE.key, PDF_TRANSACTIONS.TIME_OUT_ERROR_MESSAGE.value));
        } else if(!downloadedResp.data) {
          message.error(downloadedResp.status);
        } else if (downloadedResp?.errors?.length > 0) {
          message.error(
            downloadedResp?.errors[0]?.status
              ? downloadedResp?.errors[0]?.status
              : isMailTemplates
              ? t(`EMAIL_TRANSACTIONS:${EMAIL_TRANSACTIONS.SEND_EMAIL_FAILURE_ERROR_MESSAGE.key}`, EMAIL_TRANSACTIONS.SEND_EMAIL_FAILURE_ERROR_MESSAGE.value)
              : isPublishedMessages
              ? messageType === 'call'
                ? t(`CALL_TRANSACTIONS:${CALL_TRANSACTIONS.INITIATE_PHONE_CALL_ERROR_MESSAGE.key}`, CALL_TRANSACTIONS.INITIATE_PHONE_CALL_ERROR_MESSAGE.value)
                : messageType === 'whatsapp'
                ? t(`WHATSAPP_TRANSACTIONS:${WHATSAPP_TRANSACTIONS.SEND_WHATSAPP_ERROR_MESSAGE.key}`, WHATSAPP_TRANSACTIONS.SEND_WHATSAPP_ERROR_MESSAGE.value)
                : messageType === 'sms'
                ? t(`MESSAGE_TRANSACTIONS:${MESSAGE_TRANSACTIONS.SEND_MESSAGE_ERROR_MESSAGE.key}`, MESSAGE_TRANSACTIONS.SEND_MESSAGE_ERROR_MESSAGE.value)
                : ''
              : downloadedResp.errors[0].description,
          );
        }
      }
    } else if (isMailTemplates || isPublishedMessages || usedVariables?.length > 0) {
      setIsModalVisible(true);
      if (type === 'import') {
        uploadedExcelToJson(val, usedVariables, allSheetNames, eachSheetName);
      } else if (type === 'export') {
        apiArrayToExcel(usedVariables, selectedTemplate);
      }
    }
  };

  const onSuccessfulGeneration = (data) => {
    setDownloadZip(data.uri);
    if(data.uri)
    window.open(data.uri);
    setIsgeneratingPdf(false);
    setDownloadZip(false);
    setIsUploading(false);
    setIsUploadFailed(false);
    setDownloadedZip(true);
    if (isMailTemplates) {
      let reqID = [];
      let allMailReqStatus = [];
      let dummyVar = data?.map(eachReq => {
        reqID = [...reqID, eachReq.body.id];
        let mailReqStatus = { id: eachReq.body.id, status: eachReq.body.status };
        allMailReqStatus = [...allMailReqStatus, mailReqStatus];
      });
      setReqMailStatus(allMailReqStatus);
      setReqMailId(reqID);
    }
  }

  const downloadZipfile = async convertedData => {
    setIsgeneratingPdf(true);
    let response;
    if (isMailTemplates) {
        response = await uploadEmailDataSet(convertedData);
    } else if (isPublishedMessages) {
      if (selectedTemplate?.variables?.length === 0) {
        convertedData.map(eachData => (eachData.variables = []));
        response = await uploadMessagesDataSet(messageType, convertedData);
        setMessagesStatus(response);
      } else {
        response = await uploadMessagesDataSet(messageType, convertedData);
        setMessagesStatus(response);
      }
    } else {
      response = await uploadDataSet(selectedTemplate?.id, convertedData);     
    }
    // On API time-out
    if(!response || !response.data) {
      if(!response) {
        message.error(t(PDF_TRANSACTIONS.TIME_OUT_ERROR_MESSAGE.key, PDF_TRANSACTIONS.TIME_OUT_ERROR_MESSAGE.value)); 
      } else {
        message.error(response.status);
      }
      setIsgeneratingPdf(false);
      setDownloadZip(false);
    } else
    // 100% Success
    if (response && (!response.errors || response.errors.length === 0)) {
      onSuccessfulGeneration(response?.data);
    } else 
    // Partial Success
    if (response && response.errors.length > 0 && response.data?.uri) {
      message.error(response.errors[0].description);
      setPartialSuccess(true);
      onSuccessfulGeneration(response?.data);
    } else {
      message.error(response.errors[0].description);
      setDownloadedZip(true);
      setIsUploadFailed(true);
      setIsgeneratingPdf(false);
      setIsUploading(false);
      setDownloadZip(false);
      setIsUploading(false);
    }
  };

  const uploadMoreData = () => {
    if (isMailTemplates) {
      setIsModalVisible(false);
      clearInterval(myIntervalId.current);
    }
    setDownloadedZip(false);
    setPartialSuccess(false);
  };

  const handleClose = () => {
    showErrors(false);
  };

  const renderBody = (categoriesTemp, templatesList) => {
    return (
      <React.Fragment>
        <TemplateTitleSec isPublishedTemp={1}>
          <p className={'template_title'}>
            {isMailTemplates
              ? t(`EMAIL_TRANSACTIONS:${EMAIL_TRANSACTIONS.EMAIL_TRANSACTIONS_TITLE.key}`, EMAIL_TRANSACTIONS.EMAIL_TRANSACTIONS_TITLE.value)
              : isPublishedMessages
              ? t(TRANSACTIONS.GENERAL_TRANSACTIONS_TITLE.key, TRANSACTIONS.GENERAL_TRANSACTIONS_TITLE.value) +
                `${
                  messageType === 'call'
                    ? t(`CALL_TRANSACTIONS:${CALL_TRANSACTIONS.CALL_TRANSACTIONS_TITLE.key}`, CALL_TRANSACTIONS.CALL_TRANSACTIONS_TITLE.value)
                    : messageType === 'sms'
                    ? t(`MESSAGE_TRANSACTIONS:${MESSAGE_TRANSACTIONS.SMS_TRANSACTIONS_TITLE.key}`, MESSAGE_TRANSACTIONS.SMS_TRANSACTIONS_TITLE.value)
                    : t(`WHATSAPP_TRANSACTIONS:${WHATSAPP_TRANSACTIONS.WHATSAPP_TRANSACTIONS_TITLE.key}`, WHATSAPP_TRANSACTIONS.WHATSAPP_TRANSACTIONS_TITLE.value)
                }`
              : t(`PDF_TRANSACTIONS:${PDF_TRANSACTIONS.PDF_TRANSACTIONS_TITLE.key}`, PDF_TRANSACTIONS.PDF_TRANSACTIONS_TITLE.value)}
          </p>
        </TemplateTitleSec>
        {isLoading ? (
          <LoaderContainer style={{ marginTop: '25%' }}>
            <Loader />
          </LoaderContainer>
        ) : (
          templatesList?.length > 0 && (
            <>
              <TemplateWrapper isUploadFile={1}>
                {templatesList.map(templateObj => {
                  return (
                    <div key={templateObj.id}>
                      <div>
                        <TemplatePageOverview
                          uploadExcel={1}
                          className={
                            selectedTemplate && selectedTemplate.id === templateObj.id && 'selected'
                          }
                          key={templateObj.id}
                          title={templateObj.name}
                          onClick={() => {
                            try {
                              if (isPublishedMessages) {
                                templateObj.variables =
                                  messageType === 'whatsapp'
                                    ? templateObj.whatsappVariables
                                    : messageType === 'call'
                                    ? templateObj.callVariables
                                    : templateObj.smsVariables;
                                setSelectedTemplate(templateObj);
                              } else {
                                setSelectedTemplate(templateObj);
                              }
                              if (
                                !isMailTemplates &&
                                !isPublishedMessages &&
                                templateObj?.variables?.length === 0
                              ) {
                                getTemplateDetails(null, null, null, null, templateObj);
                              }
                              if (
                                isMailTemplates ||
                                isPublishedMessages ||
                                templateObj?.variables?.length > 0
                              ) {
                                onTempSelection(currentStep + 1);
                                setCurrentStep(currentStep + 1);
                                if (templateObj?.variables?.length > 0) {
                                  let usedVariables = templateObj?.variables;
                                  let tableVariables = [];
                                  usedVariables.map(
                                    eachVar =>
                                      eachVar.type === 'table' && tableVariables.push([eachVar]),
                                  );
                                  setTableVariables(tableVariables);
                                }
                              }
                            } catch (e) {
                              console.log('error on clicking publish template!! ', e);
                            }
                          }}
                        >
                          <TemplateImage uploadExcel={1}>
                            <Icon
                              component={
                                isMailTemplates
                                  ? SendEmailIcon
                                  : isPublishedMessages
                                  ? messageType === 'call'
                                    ? callSvgIcon
                                    : messageType === 'whatsapp'
                                    ? whatsappSvgIcon
                                    : messageType === 'sms'
                                    ? smsSvgIcon
                                    : ''
                                  : PDFSvg
                              }
                            />
                          </TemplateImage>
                          <div className="template_name">
                            <div className="name">{templateObj.name} </div>
                            <div className="categoryName">
                              <div className="box2"></div>
                              {categoriesTemp.length > 0 &&
                                categoriesTemp.map(
                                  category =>
                                    templateObj.categoryId === category.categoryId && (
                                      <div className="categ_Name" key={category.categoryId}>
                                        {category.categoryName}
                                      </div>
                                    ),
                                )}
                            </div>
                          </div>
                        </TemplatePageOverview>
                      </div>
                    </div>
                  );
                })}
              </TemplateWrapper>
            </>
          )
        )}
        {!isLoading && templatesList?.length === 0 && (
          <EmptySettingsDetails style={{ marginTop: '25%' }}>
            <div className="empty-illustration">
              <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
            </div>
              <div className="empty-txt" style={{ color: 'black' }}>
                <span>{t(TRANSACTIONS.TEMPLATE_LIST_EMPTY_MESSAGE.key, TRANSACTIONS.TEMPLATE_LIST_EMPTY_MESSAGE.value)}</span>
              </div>
          </EmptySettingsDetails>
        )}
      </React.Fragment>
    );
  };

  const renderSearchBody = () => {
    return (
      <React.Fragment>
        <UploadSteps currentStep={currentStep > 0}>
          <Steps current={currentStep} direction="vertical">
            {steps.map(item => (
              <Step key={item.title} title={item.title} />
            ))}
            <Lottie
              options={defaultOptions}
              className="lottie"
              height="40%"
              width="50%"
              style={{ marginTop: '50%' }}
              speed={0.3}
              isStopped={false}
              isPaused={false}
            />
          </Steps>
          <div className="uploadSection">
            <div className="steps-content" style={{ width: '70vw' }}>
              {steps[currentStep].content}
            </div>
            <div className={`${currentStep > 0 ? 'previous steps-action' : 'next steps-action'}`}>
              {currentStep > 0 && (
                <Button
                  style={{ marginLeft: 8 }}
                  onClick={() => {
                    onTempSelection(currentStep - 1);
                    setErrorMessage(null);
                    setCurrentStep(currentStep - 1);
                    setIsgeneratingPdf(false);
                    setIsUploading(false);
                    setDownloadZip(false);
                  }}
                >
                  {t(TRANSACTIONS.MOVE_TO_SELECT_A_TEMPLATE_STEP_BUTTON.key, TRANSACTIONS.MOVE_TO_SELECT_A_TEMPLATE_STEP_BUTTON.value)}
                </Button>
              )}
            </div>
          </div>
        </UploadSteps>
      </React.Fragment>
    );
  };
  const getDistinctItemsByVariableId = (inputArray) => {
    const uniqueVariableIds = new Set();
  
    // Use filter() to get distinct items based on 'name'
    return inputArray.filter(item => {
      if (!uniqueVariableIds.has(item.name)) {
        uniqueVariableIds.add(item.name);
        return true;
      }
      return false;
    });
  }

  const steps = [
    {
      title: (
        <div>
          {t(TRANSACTIONS.SELECT_A_TEMPLATE_STEP_TITLE.key, TRANSACTIONS.SELECT_A_TEMPLATE_STEP_TITLE.value)} <br />
        </div>
      ),
      content: renderBody(tempCategories, templatesList),
    },
    {
      title: t(TRANSACTIONS.UPLOAD_EXCEL_FILE_STEP_TITLE.key, TRANSACTIONS.UPLOAD_EXCEL_FILE_STEP_TITLE.value),
      content: (
        <ErrorMessage
          isError={errorMessage ? 1 : 0}
          width={errorMessage && missingVarList.length > 3 ? '90%' : '100%'}
          downloadZip={downloadZip}
          isUploading={isUploading}
          accessMailRoomData={isMailRoomModuleEnabled ? 1 : 0}
        >
          {selectedTemplate && (
            <TempDetails accessMailRoomData={isMailRoomModuleEnabled ? 1 : 0}>
              <div className="tempDetail">
                <div>
                  {t(TRANSACTIONS.SELECTED_TEMPLATE_TITLE.key, TRANSACTIONS.SELECTED_TEMPLATE_TITLE.value)}
                  <p
                    style={{
                      paddingLeft: 0,
                    }}
                  >
                    {selectedTemplate?.name}
                  </p>
                </div>
                <div>
                  {t(TRANSACTIONS.TEMPLATE_VARIABLES_TITLE.key, TRANSACTIONS.TEMPLATE_VARIABLES_TITLE.value)}
                  <div className="variables">
                    {selectedTemplate?.variables &&
                      getDistinctItemsByVariableId(selectedTemplate?.variables).map(
                        (variable, index) => index < 3 && <p>{variable.name}</p>,
                      )}
                    <p
                      className={
                        selectedTemplate?.variables?.length === 0
                          ? 'varDetails noVar'
                          : 'varDetails'
                      }
                      onClick={() => {
                        selectedTemplate?.variables?.length > 0 && setIsViewVarDetails(true);
                        setViewTagDetails(false);
                        setViewMissedList(false);
                      }}
                    >
                      {selectedTemplate?.variables?.length === 0
                        ? t(TRANSACTIONS.NO_VARIABLES.key, TRANSACTIONS.NO_VARIABLES.value)
                        : selectedTemplate?.variables?.length > 3
                        ? t(TRANSACTIONS.SEE_ALL_TEMPLATE_VARIABLES_ACTION.key, TRANSACTIONS.SEE_ALL_TEMPLATE_VARIABLES_ACTION.value)
                        : t(TRANSACTIONS.TEMPLATE_VARIABLES_DETAILS_ACTION.key, TRANSACTIONS.TEMPLATE_VARIABLES_DETAILS_ACTION.value)}
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <Button onClick={() => getTemplateDetails('export')}>
                  {t(TRANSACTIONS.DOWNLOAD_SAMPLE_FILE_FORMAT_BUTTON.key, TRANSACTIONS.DOWNLOAD_SAMPLE_FILE_FORMAT_BUTTON.value)} <Icon type="download" />{' '}
                </Button>
              </div>
            </TempDetails>
          )}
          <div className="errorSection">
            {errorMessage && isShowErrors && (
              <Alert
                message={
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <p className="errMsg">{errorMessage}</p>
                    {errorMessage && missingVarList.length > 3 && (
                      <p
                        className="seeAllError"
                        onClick={() => {
                          setViewMissedList(true);
                          setIsViewVarDetails(true);
                          setViewTagDetails(false);
                        }}
                      >
                        {t(TRANSACTIONS.SEE_ALL_TEMPLATE_VARIABLES_ACTION.key, TRANSACTIONS.SEE_ALL_TEMPLATE_VARIABLES_ACTION.value)}
                      </p>
                    )}
                  </div>
                }
                type="error"
                closable
                afterClose={() => handleClose()}
              />
            )}
          </div>
          {(isUploading || downloadZip) && !errorMessage ? (
            <BulkUploadButton
              isUploading={1}
              // className="generatePDF"
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  cursor: downloadZip && 'pointer',
                }}
              >
                <Icon
                  style={{ marginBottom: downloadZip ? '' : '15px' }}
                  component={
                    downloadZip
                      ? isMailTemplates
                        ? EmailIcon
                        : isPublishedMessages
                        ? messageType === 'call'
                          ? callSvgIcon
                          : messageType === 'whatsapp'
                          ? whatsappSvgIcon
                          : messageType === 'sms'
                          ? smsSvgIcon
                          : ''
                        : PDFSvg
                      : downloadedZip
                      ? isMailTemplates
                        ? EmailIcon
                        : isPublishedMessages
                        ? messageType === 'call'
                          ? callSvgIcon
                          : messageType === 'whatsapp'
                          ? whatsappSvgIcon
                          : messageType === 'sms'
                          ? smsSvgIcon
                          : ''
                        : PDFSvg
                      : UploadVariableSvg
                  }
                />
                <p className={downloadZip || downloadedZip ? 'downloadZip' : ''}>
                  <Icon
                    type={
                      generatingPdf || isUploading
                        ? 'loading'
                        : downloadZip
                        ? ''
                        : downloadedZip
                        ? ''
                        : 'loading'
                    }
                    style={{ marginRight: '5px', fontSize: '15px' }}
                  />
                  {isUploading
                    ? t(TRANSACTIONS.UPLOADING_SAMPLE_FILE_DATA.key, TRANSACTIONS.UPLOADING_SAMPLE_FILE_DATA.value)
                    : generatingPdf
                    ? isMailTemplates
                      ? t(`EMAIL_TRANSACTIONS:${EMAIL_TRANSACTIONS.SENDING_EMAIL_TEMPLATE_TO_MAIL.key}`, EMAIL_TRANSACTIONS.SENDING_EMAIL_TEMPLATE_TO_MAIL.value)
                      : isPublishedMessages
                      ? messageType === 'call'
                        ? t(`CALL_TRANSACTIONS:${CALL_TRANSACTIONS.INITIATING_CALL_MESSAGE.key}`, CALL_TRANSACTIONS.INITIATING_CALL_MESSAGE.value)
                        : messageType === 'whatsapp'
                        ? t(`WHATSAPP_TRANSACTIONS:${WHATSAPP_TRANSACTIONS.SENDING_WHATSAPP_MSG_MESSAGE.key}`, WHATSAPP_TRANSACTIONS.SENDING_WHATSAPP_MSG_MESSAGE.value)
                        : messageType === 'sms'
                        ? t(`MESSAGE_TRANSACTIONS:${MESSAGE_TRANSACTIONS.SENDING_SMS_MESSAGE.key}`, MESSAGE_TRANSACTIONS.SENDING_SMS_MESSAGE.value)
                        : ''
                      : t(`PDF_TRANSACTIONS:${PDF_TRANSACTIONS.GENERATING_PDF_MESSAGE.key}`, PDF_TRANSACTIONS.GENERATING_PDF_MESSAGE.value)
                    : downloadZip
                    ? isMailTemplates
                      ? t(`EMAIL_TRANSACTIONS:${EMAIL_TRANSACTIONS.SENDING_EMAIL_TEMPLATE_TO_MAIL.key}`, EMAIL_TRANSACTIONS.SENDING_EMAIL_TEMPLATE_TO_MAIL.value)
                      : isPublishedMessages
                      ? messageType === 'call'
                        ? t(`CALL_TRANSACTIONS:${CALL_TRANSACTIONS.INITIATING_CALL_MESSAGE.key}`, CALL_TRANSACTIONS.INITIATING_CALL_MESSAGE.value)
                        : messageType === 'whatsapp'
                        ? t(`WHATSAPP_TRANSACTIONS:${WHATSAPP_TRANSACTIONS.SENDING_WHATSAPP_MSG_MESSAGE.key}`, WHATSAPP_TRANSACTIONS.SENDING_WHATSAPP_MSG_MESSAGE.value)
                        : messageType === 'sms'
                        ? t(`MESSAGE_TRANSACTIONS:${MESSAGE_TRANSACTIONS.SENDING_SMS_MESSAGE.key}`, MESSAGE_TRANSACTIONS.SENDING_SMS_MESSAGE.value)
                        : ''
                      : t(`PDF_TRANSACTIONS:${PDF_TRANSACTIONS.GENERATING_PDF_MESSAGE.key}`, PDF_TRANSACTIONS.GENERATING_PDF_MESSAGE.value)
                    : ''}
                </p>
              </div>
            </BulkUploadButton>
          ) : (
            <Upload
              accept=".xls, .xlsx"
              showUploadList={false}
              className="varUpload"
              beforeUpload={isMailTemplates ? (file) => beforeUploadEmailTransaction(file) : (file) => {
                if (tableVariablesInTemp?.length > 0) {
                  let allSheetNames;
                  readSheetNames(file).then(sheetNames => {
                    allSheetNames = sheetNames;
                    if (allSheetNames && allSheetNames.length > 0) {
                      for (var n = 1; n <= tableVariablesInTemp.length + 1; n++) {
                        let eachSheetName = allSheetNames[n - 1];
                        readXlsxFile(file, { sheet: n }).then(
                          function(rows) {
                            let validRows = rows.map(eachRow => {
                              if (!eachRow.every(element => element === null)) {
                                return eachRow;
                              }
                            });
                            validRows = validRows?.filter(element => {
                              return element !== undefined;
                            });
                            getTemplateDetails('import', validRows, allSheetNames, eachSheetName);
                          },
                          function(error) {
                            let uploadedFileType = file?.name?.split('.')[1];
                            if (uploadedFileType === 'xls' || uploadedFileType === 'xlsx') {
                              setErrorMessage(t(TRANSACTIONS.UPLOADED_EMPTY_EXCEL_FILE_ERROR_MESSAGE.key, TRANSACTIONS.UPLOADED_EMPTY_EXCEL_FILE_ERROR_MESSAGE.value));
                            } else {
                              setErrorMessage(t(TRANSACTIONS.WRONG_FILE_UPLOADED_ERROR_MESSAGE.key, { fileType: uploadedFileType }));
                            }
                            showErrors(true);
                          },
                        );
                      }
                    }
                  });
                } else {
                  readXlsxFile(file).then(
                    function(rows) {
                      let validRows = rows.map(eachRow => {
                        if (!eachRow.every(element => element === null)) {
                          return eachRow;
                        }
                      });
                      validRows = validRows?.filter(element => {
                        return element !== undefined;
                      });
                      getTemplateDetails('import', validRows);
                    },
                    function(error) { 
                      if (checkFileFormat(file.name)) {
                        setErrorMessage(t(TRANSACTIONS.UPLOADED_EMPTY_EXCEL_FILE_ERROR_MESSAGE.key, TRANSACTIONS.UPLOADED_EMPTY_EXCEL_FILE_ERROR_MESSAGE.value));
                      } else {
                        setErrorMessage(
                          t(TRANSACTIONS.WRONG_FILE_UPLOADED_ERROR_MESSAGE.key, TRANSACTIONS.WRONG_FILE_UPLOADED_ERROR_MESSAGE.value)
                        );
                      };
                      showErrors(true);
                    },
                  );
                }
              }}
            >
              <BulkUploadButton>
                <Icon style={{ marginBottom: '15px' }} component={UploadVariableSvg} />
                <p className="import">{t(TRANSACTIONS.DRAG_AND_DROP_FILE_TITLE.key, TRANSACTIONS.DRAG_AND_DROP_FILE_TITLE.value)}</p>
                <p className="desc">
                  ({t(TRANSACTIONS.DRAG_AND_DROP_FILE_DESCRIPTION.key, TRANSACTIONS.DRAG_AND_DROP_FILE_DESCRIPTION.value)}{' '}
                  {isMailTemplates
                    ? t(`EMAIL_TRANSACTIONS:${EMAIL_TRANSACTIONS.SEND_YOUR_EMAIL_MESSAGE.key}`, EMAIL_TRANSACTIONS.SEND_YOUR_EMAIL_MESSAGE.value)
                    : isPublishedMessages
                    ? messageType === 'call'
                      ? t(`CALL_TRANSACTIONS:${CALL_TRANSACTIONS.CALL_TRANSACTIONS_TITLE.key}`, CALL_TRANSACTIONS.CALL_TRANSACTIONS_TITLE.value)
                      : messageType === 'whatsapp'
                      ? t(`WHATSAPP_TRANSACTIONS:${WHATSAPP_TRANSACTIONS.WHATSAPP_TRANSACTIONS_TITLE.key}`, WHATSAPP_TRANSACTIONS.WHATSAPP_TRANSACTIONS_TITLE.value)
                      : messageType === 'sms'
                      ? t(`MESSAGE_TRANSACTIONS:${MESSAGE_TRANSACTIONS.SMS_TRANSACTIONS_TITLE.key}`, MESSAGE_TRANSACTIONS.SMS_TRANSACTIONS_TITLE.value)
                      : ''
                    : t(TRANSACTIONS.GENERATE_DOCUMENT_MESSAGE.key, TRANSACTIONS.GENERATE_DOCUMENT_MESSAGE.value)}
                  )
                </p>
              </BulkUploadButton>
            </Upload>
          )}
        </ErrorMessage>
      ),
    },
  ];

  return (
    <Container isUploadFile={1}>
      <TemplateConatiner isUploadFile={1}>
        <div>{renderSearchBody(tempCategories, templatesList)}</div>
        {!isLoading && currentStep === 0 && templatesList?.length > 0 && (
          <>
            {templatesList?.length !== totalTemplates && templatesList.length >= 6 && (
              <div className="addMore">
                <Icon type="loading" />
                {t(TRANSACTIONS.LOADING_MORE_TEMPLATES_MESSAGE.key, TRANSACTIONS.LOADING_MORE_TEMPLATES_MESSAGE.value)}
              </div>
            )}
            {templatesList?.length === totalTemplates && templatesList.length !== 0 && (
              <div className="allData">
                {t(TRANSACTIONS.GOT_ALL_TEMPLATES_MESSAGE.key, TRANSACTIONS.GOT_ALL_TEMPLATES_MESSAGE.value)}
              </div>
            )}
          </>
        )}
      </TemplateConatiner>
      {((downloadedZip && isModalVisible) || isViewVarDetails) && (
        <>
          <VariableUploadResultModal
            visible={isModalVisible && downloadedZip}
            reqMailStatus={reqMailStatus}
            isMailTemplates={isMailTemplates}
            isPublishedMessages={isPublishedMessages}
            messageType={messageType}
            onCancel={uploadMoreData}
            isUploadFailed={isUploadFailed}
            messagesStatus={messagesStatus}
            tableVariablesInTemp={tableVariablesInTemp}
            setErrorMessage={e => {
              setErrorMessage(e);
              showErrors(true);
            }}
            getDetails={(e, validRows, allSheetNames, eachSheetName) =>
              getTemplateDetails(e, validRows, allSheetNames, eachSheetName)
            }
            partialSuccess={partialSuccess}
          />
          <VariableDetailsModal
            visible={isViewVarDetails}
            isViewTags={isViewTagDetails}
            isPublishedMessages={isPublishedMessages}
            tagsData={tagsData}
            isMissedVarList={isViewMissedList}
            variables={
              isViewMissedList && missingVarList?.length > 0
                ? missingVarList
                : getDistinctItemsByVariableId(selectedTemplate && selectedTemplate?.variables)
            }
            onCancel={() => setIsViewVarDetails(false)}
            isGeneratingPDF={generatingPdf}
          />
        </>
      )}
    </Container>
  );
};

export default withTranslation(NAMESPACES)(PublishedTemplates);
